import { render } from "./Change.vue?vue&type=template&id=f73b5f12&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"

import "./Change.vue?vue&type=style&index=0&id=f73b5f12&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f73b5f12"

export default script